import angular from 'angular';

import { MassMessagingConfirmSendController } from './mass-messaging-confirm-send.controller';
import { MassMessagingService } from './mass-messaging.service.js';

angular
  .module('mass-messaging', [])
  .controller('MassMessagingConfirmSendController', MassMessagingConfirmSendController)
  .factory('MassMessagingFactory', MassMessagingService.MassMessagingFactory)
